import React, { useState } from 'react';
import { profileApi } from '../../../services/api';
import AddEditModal from '../shared/AddEditModal';
import ItemCard from '../shared/ItemCard';

const industryFields = [
    { name: 'domain', label: 'اسم القطاع/المجال', type: 'text', required: true, placeholder: 'مثال: التجارة الإلكترونية، الرعاية الصحية، الطيران، ERP/SAP' },
    { name: 'experience_level', label: 'مستوى الخبرة', type: 'select', options: [
        { value: 'Professional', label: 'مهني - عمل بدوام كامل مدفوع' },
        { value: 'Freelance', label: 'عمل حر - عمل تعاقدي/حر' },
        { value: 'Project', label: 'مشروع - مشاريع شخصية/أكاديمية' },
        { value: 'Consulting', label: 'استشاري - عمل استشاري' },
        { value: 'Internship', label: 'تدريب - برنامج تدريبي' },
        { value: 'Volunteer', label: 'تطوعي - عمل تطوعي' }
    ]},
    { name: 'projects_notes', label: 'المشاريع والملاحظات', type: 'textarea', placeholder: 'صف المشاريع والخبرة في هذا القطاع...' }
];

const domainLabels = {
    healthcare: 'الرعاية الصحية والطبية',
    aviation: 'الطيران والفضاء',
    finance: 'المالية والبنوك',
    retail: 'التجزئة والتجارة الإلكترونية',
    manufacturing: 'التصنيع',
    energy: 'الطاقة والمرافق',
    education: 'التعليم وتقنيات التعليم',
    government: 'الحكومة والقطاع العام',
    logistics: 'اللوجستيات وسلسلة التوريد',
    real_estate: 'العقارات والبناء',
    telecommunications: 'الاتصالات',
    media: 'الإعلام والترفيه',
    hospitality: 'الضيافة والسياحة',
    agriculture: 'الزراعة والغذاء',
    automotive: 'السيارات',
    insurance: 'التأمين',
    legal: 'القانون والامتثال',
    nonprofit: 'غير ربحي ومنظمات المجتمع المدني',
    other: 'أخرى'
};

export default function IndustryExperience({ profile, onRefresh }) {
    const [showModal, setShowModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [loading, setLoading] = useState(false);

    const industryExperience = profile?.industryExperience || [];

    const handleAdd = () => {
        setEditItem(null);
        setShowModal(true);
    };

    const handleEdit = (item) => {
        setEditItem(item);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('هل أنت متأكد من حذف خبرة القطاع هذه؟')) return;
        setLoading(true);
        try {
            await profileApi.deleteIndustryExperience(id);
            onRefresh('industryExperience');
        } catch (err) {
            alert('فشل في حذف خبرة القطاع');
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (data) => {
        setLoading(true);
        try {
            if (editItem) {
                await profileApi.updateIndustryExperience(editItem.id, data);
            } else {
                await profileApi.addIndustryExperience(data);
            }
            setShowModal(false);
            onRefresh('industryExperience');
        } catch (err) {
            alert('فشل في حفظ خبرة القطاع');
        } finally {
            setLoading(false);
        }
    };

    const renderCard = (industry) => (
        <ItemCard
            key={industry.id}
            title={domainLabels[industry.domain] || industry.domain}
            subtitle={industry.experience_level || 'مهني'}
            description={industry.projects_notes}
            onEdit={() => handleEdit(industry)}
            onDelete={() => handleDelete(industry.id)}
        />
    );

    return (
        <div className="section-container">
            <div className="section-header">
                <h2 className="section-title">خبرة القطاع</h2>
                <button className="add-button" onClick={handleAdd}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    إضافة قطاع
                </button>
            </div>

            {industryExperience.length === 0 ? (
                <div className="empty-state">
                    <div className="empty-state-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <path d="M2 20h20"></path>
                            <path d="M5 20V8.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C6.52 5 7.08 5 8.2 5h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C19 6.52 19 7.08 19 8.2V20"></path>
                            <path d="M12 5V2"></path>
                            <path d="M9 9h6"></path>
                            <path d="M9 13h6"></path>
                            <path d="M9 17h6"></path>
                        </svg>
                    </div>
                    <h3 className="empty-state-title">لا توجد خبرة قطاعية بعد</h3>
                    <p className="empty-state-description">أضف القطاعات والمجالات التي لديك خبرة في العمل بها</p>
                    <button className="add-button" onClick={handleAdd}>أضف قطاعك الأول</button>
                </div>
            ) : (
                <div className="items-grid">
                    {industryExperience.map(renderCard)}
                </div>
            )}

            {showModal && (
                <AddEditModal
                    title={editItem ? 'تعديل خبرة القطاع' : 'إضافة خبرة قطاع'}
                    fields={industryFields}
                    initialData={editItem || { experience_level: 'Professional' }}
                    onSave={handleSave}
                    onClose={() => setShowModal(false)}
                    loading={loading}
                />
            )}
        </div>
    );
}
